import { render } from "./ViewOrder.html?vue&type=template&id=735eac4d&scoped=true"
import script from "./ViewOrder.js?vue&type=script&lang=js"
export * from "./ViewOrder.js?vue&type=script&lang=js"

import "./ViewOrder.css?vue&type=style&index=0&id=735eac4d&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735eac4d"]])

export default __exports__